<template>
  <div className="box5 flex-col">
    <div className="section11 flex-col">
      <span className="info13">最近入场记录</span>
      <div className="layer7 flex-col">
        <div className="mod2 flex-row">
          <span className="word26">车牌号</span>
          <span className="word27">车辆类型</span>
          <span className="word28">入场时间</span>
          <span className="txt7">入场方式</span>
          <!-- <span className="word29">其他</span> -->
          <span className="word29">操作</span>
        </div>
      </div>
      <div className="layer9 flex-col" v-for="item in inCarFltter" :key="item.id">
        <div className="section12 flex-row">
          <span className="word34">{{ item.numberPlate }}</span>
          <div className="outer5 flex-col">
            <span className="word35">{{ getNameByFlagKey(item.carType) }}</span>
          </div>
          <span className="info14">{{ getTime(Number(item.inTime)) }}</span>
          <span className="word36">{{
            getReleaseText(item.inReleaseType)
          }}</span>
          <div className="action-group">
            <span className="action-btn action-btn--warn" @click="editCar(item)">纠错</span>
            <span className="action-btn action-btn--primary" v-if="item.inReleaseType==0" @click="handleAction2(item, 0)">放行</span>
            <span className="action-tag action-tag--done" v-if="item.inReleaseType>0">已放行</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div className="box7 flex-col">
    <div className="wrap5 flex-col">
      <span className="word58">最近出场记录</span>
      <div className="main4 flex-col">
        <div className="outer8 flex-row">
          <span className="word59">车牌号</span>
          <span className="word60">车辆类型</span>
          <span className="word61">入场时间</span>
          <span className="word62">出场时间</span>
          <span className="txt23">出场方式</span>
          <span className="word29">操作</span>
        </div>
      </div>
      <div className="main6 flex-col" v-for="item in outCarFltter" :key="item.id">
        <div className="main7 flex-row">
          <span className="word65">{{ item.numberPlate }}</span>
          <div className="bd14 flex-col">
            <span className="word66">{{ getNameByFlagKey(item.carType) || '-' }}</span>
          </div>
          <span className="info28">{{ getTime(Number(item.inTime)) }}</span>
          <span className="info29">{{ getTime(Number(item.outTime)) }}</span>
          <span className="word67">{{
            getReleaseText(Number(item.outReleaseType))
          }}</span>
          <div className="action-group">
            <span className="action-btn action-btn--warn" @click="editCar(item)">纠错</span>
            <span className="action-btn action-btn--primary" v-if="item.outReleaseType===0" @click="handleAction2(item, 1)">放行</span>
            <span className="action-tag action-tag--done" v-if="item.outReleaseType>0" @click="cancelOut(item)">取消出场</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-dialog :title="reasonTitle" v-model="openDoorDialogVisible" :modal-append-to-body="false" width="30%" center>
    <div class="Box" v-if="direction===0">
      <div v-for="(item, index) of releaseInReason" :key="index" :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
           @click="onReason(index)">
        {{ item }}
      </div>
    </div>
    <div class="Box" v-if="direction===1">
      <div v-for="(item, index) of releaseOutReason" :key="index" :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
           @click="onReason(index)">
        {{ item }}
      </div>
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button type="danger" @click="openDoor()" :disabled="reasonIndex === ''">确 定</el-button>
      </span>
    </template>
  </el-dialog>

  <!-- 放行入场弹窗 -->
  <el-dialog
    v-model="releaseInConfirmVisible"
    title="放行入场"
    :modal-append-to-body="false"
    width="40%"
    center
    :close-on-click-modal="false"
    class="release-in-dialog"
  >
    <div class="release-in-card">
      <el-form label-width="96px" label-position="left" class="release-in-form">
        <el-form-item label="车牌">
          <span class="release-in-value">
            {{ releaseInConfirmItem?.numberPlate || "-" }}
          </span>
        </el-form-item>
        <el-form-item label="类型">
          <span class="release-in-value">
            {{ getNameByFlagKey(releaseInConfirmItem?.carType) || "-xxx" }}
          </span>
        </el-form-item>
        <el-form-item label="入场时间">
          <span class="release-in-value">
            {{
              releaseInConfirmItem?.inTime
                ? getTime(Number(releaseInConfirmItem.inTime))
                : "-"
            }}
          </span>
        </el-form-item>
        <el-form-item label="入场通道">
          <span class="release-in-value">
            {{ getInChannelText(releaseInConfirmItem) }}
          </span>
        </el-form-item>
      </el-form>
    </div>
    <div class="Box">
      <div v-for="(item, index) of releaseInReason" :key="index" :class="index === reasonIndex ? 'reasonBox_ac' : 'reasonBox'"
           @click="onReason(index)">
        {{ item }}
      </div>
    </div>

    <template #footer>
      <div class="release-in-footer">
        <el-button class="release-in-primary" type="primary" @click="confirmReleaseIn">
          确认入场
        </el-button>
        <el-button @click="releaseInConfirmVisible = false">取消放行</el-button>
      </div>
    </template>
  </el-dialog>

  <!-- 纠错弹框 -->
  <el-dialog
    v-model="editCarDialogVisible"
    title="纠错"
    :modal-append-to-body="false"
    width="520px"
    center
    :close-on-click-modal="false"
    class="release-in-dialog"
  >
    <div class="release-in-card">
      <el-form label-width="96px" label-position="left" class="release-in-form">
        <el-form-item label="当前车牌">
          <span class="release-in-value">
            {{ editCarItem?.numberPlate || "-" }}
          </span>
        </el-form-item>
        <el-form-item label="修改为">
          <div class="edit-plate-field" ref="platePickerRef">
            <div class="edit-plate-composite">
              <el-input
                v-model="editCarFull"
                class="edit-plate-body-input"
                placeholder="请输入完整车牌号"
                clearable
                @focus="provincePickerVisible = true"
              />
              <button
                type="button"
                class="edit-plate-province-badge"
                title="选择省份简称"
                @click.stop="toggleProvincePicker"
              >
                {{ getCurrentProvince() || "▼" }}
              </button>
            </div>
            <div
              v-show="provincePickerVisible"
              class="edit-plate-keyboard"
              @click.stop
            >
              <div
                v-for="(row, ri) in plateKeyboardRows"
                :key="ri"
                class="edit-plate-key-row"
              >
                <button
                  v-for="cell in row"
                  :key="cell"
                  type="button"
                  class="edit-plate-key"
                  :class="{ 'is-active': cell === getCurrentProvince() }"
                  @click="pickProvince(cell)"
                >
                  {{ cell }}
                </button>
              </div>
            </div>
          </div>
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="release-in-footer">
        <el-button type="primary" @click="confirmEditCar">确认纠错</el-button>
        <el-button @click="editCarDialogVisible = false">取消</el-button>
      </div>
    </template>
  </el-dialog>


</template>
<script>
import { mapGetters, mapState } from "vuex";
import { $timeFormat } from "../../utils/index";
import {ElMessage, ElMessageBox} from "element-plus";
import {simpleModifications, oneClickRelease, cancelUseLogOut} from "@/network/api";
import { cloneDeep } from "lodash";
import store from "../../store/index";

/**
 * 省份简称键盘布局（与常见补录/选牌 UI 一致，10 列 × 4 行）
 * 含港澳及部分特殊号牌字头
 */
const PLATE_KEYBOARD_ROWS = [
  ["京", "津", "沪", "渝", "冀", "豫", "云", "辽", "黑", "湘"],
  ["皖", "鲁", "新", "苏", "浙", "赣", "鄂", "桂", "甘", "晋"],
  ["蒙", "陕", "吉", "闽", "贵", "粤", "青", "藏", "川", "宁"],
  ["琼", "使", "领", "电", "警", "学", "挂", "港", "澳", "试"],
  ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"],
  ["Q", "W", "E", "R", "T", "Y", "U", "P", "A", "S"],
  ["D", "F", "G", "H", "J", "K", "L", "Z", "X", "C"],
  ["V", "B", "N", "M", "临", "", "", "", "", ""],
];

const PLATE_VALID_FIRST_CHARS = new Set(PLATE_KEYBOARD_ROWS.flat());

export default {
  data() {
    return {
      carParkReleaseType: [
        { key: 0, name: "未知" },
        { key: 1, name: "自动抬杆" },
        { key: 2, name: "人工抬杆" },
        { key: 3, name: "手机放行" },
        { key: 4, name: "手机扫码" },
        { key: 5, name: "异常放行" },
      ],
      openDoorDialogVisible: false,
      currentUseLog: {},
      direction: "",
      reasonIndex: "",
      reasonTitle: "",
      releaseInConfirmVisible: false,
      releaseInConfirmItem: null,
      editCarDialogVisible: false,
      editCarItem: null,
      editCarFull: "",
      plateKeyboardRows: PLATE_KEYBOARD_ROWS,
      provincePickerVisible: false,
    };
  },
  created() {
    // 获取所有的车辆类型
    this.$store.dispatch("getAllCarType");    
  },
  computed: {
    ...mapState(["inCar", "outCar", "carTypeList","releaseInReason","releaseOutReason"]),
    ...mapGetters(["carParkId"]),
    inCarFltter() {
      return this.inCar.filter((i) => i.carParkId === this.carParkId);
    },
    outCarFltter() {
      // console.log(this.outCar.filter((i) => i?.carParkId === this.carParkId));
      return this.outCar.filter((i) => i?.carParkId === this.carParkId);
    },
  },
  methods: {
    getNameByFlagKey(flagKey) {
      const arr = this.carTypeList;
      const foundItem = arr.find((item) => item.flagKey === flagKey);
      // return foundItem ? foundItem.name : null;
      return foundItem ? foundItem.name : '---';
    },
    getTime(time) {
      return $timeFormat(time, "MM-DD HH:mm:ss");
    },
    getReleaseText(type) {
      return this.carParkReleaseType.filter((i) => i.key == type)[0]?.name;
    },
    getInChannelText(item) {
      if (!item) return "-";
      return (
        item.inCheckPointName ||
        item.inChannelName ||
        item.inLaneName ||
        item.inGateName ||
        item.inPassageName ||
        item.inDeviceName ||
        item.checkPointName ||
        item.channelName ||
        item.laneName ||
        item.gateName ||
        item.deviceName ||
        item?.inCheckPoint?.name ||
        item?.checkPoint?.name ||
        "-"
      );
    },
    /** 获取当前输入框中的省份简称（若首字合法则返回，否则返回空） */
    getCurrentProvince() {
      const raw = (this.editCarFull || "").trim();
      if (!raw) return "";
      const first = raw.charAt(0);
      return PLATE_VALID_FIRST_CHARS.has(first) ? first : "";
    },
    /** 点击省份键盘：输入框已有内容则替换首字，否则填入 */
    pickProvince(cell) {
      // const raw = (this.editCarFull || "").trim();
      // if (raw && PLATE_VALID_FIRST_CHARS.has(raw.charAt(0))) {
      //   this.editCarFull = cell + raw.slice(1);
      // } else {
      //   this.editCarFull = cell;
      // }
      // this.provincePickerVisible = false;
      this.editCarFull += cell;
    },
    toggleProvincePicker() {
      this.provincePickerVisible = !this.provincePickerVisible;
    },
    closeProvincePickerOutside(e) {
      const el = this.$refs.platePickerRef;
      if (!el || !this.provincePickerVisible) return;
      if (el.contains(e.target)) return;
      this.provincePickerVisible = false;
    },
    editCar(item) {
      this.editCarItem = item;
      this.editCarFull = (item.numberPlate || "").trim();
      this.provincePickerVisible = false;
      this.editCarDialogVisible = true;
    },
    async confirmEditCar() {
      const fullPlate = (this.editCarFull || "").trim().toUpperCase();
      if (!fullPlate) {
        ElMessage.warning("请输入完整车牌号");
        return;
      }
      if (fullPlate.length < 5) {
        ElMessage.warning("车牌号长度不能少于5位");
        return;
      }
      var {message } = await simpleModifications({
        numberPlate: fullPlate,
        id: this.editCarItem.id,
      });

      var list = cloneDeep(this.inCar);
      list.map((i) => {
        if (i.id === this.editCarItem.id) {
          i.numberPlate = fullPlate;
        }
      });
      store.commit("SETALLIN", list);
      this.editCarDialogVisible = false;
      ElMessage({
        type: "success",
        message,
      });
    },
    onReason(index) {
      this.reasonIndex = index;
    },
    async handleAction(item, _direction) {
      if(_direction===0){
        this.reasonTitle = "放行入场原因";
      }else{
        this.reasonTitle = "放行出场原因";
      }
      this.openDoorDialogVisible = true;
      this.currentUseLog = item;
      this.direction = _direction;
    },

    async handleAction2(item, _direction) {
      // 入场“放行”二次确认弹窗（展示入场信息）
      this.releaseInConfirmItem = item;
      this.direction = _direction;
      this.releaseInConfirmVisible = true;
    },
    async confirmReleaseIn() {
      if (!this.releaseInConfirmItem) return;
      // 复用现有 openDoor 逻辑：入场 direction=0，默认取第一个原因
      this.currentUseLog = this.releaseInConfirmItem;
      this.releaseInConfirmVisible = false;
      await this.openDoor({
        reason:''
      });
      this.releaseInConfirmItem = null;
    },
    async cancelOut(item) {
      ElMessageBox.confirm(`确定取消【${item.numberPlate}】出场吗？`, "提示", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
            var { message, code } = await cancelUseLogOut({
              id: item.id
            });
            this.openDoorDialogVisible = false;
            if(code === 10002){
              item.outReleaseType = 2;
              var list = cloneDeep(this.outCar);
              list.map((i) => {
                if (i.id === item.id) {
                  i = item;
                }
              });
              this.outCar = list;
              store.commit("SETALLOUT", this.outCar);
            }else{
              this.$message({
                message,
                type: "error",
              });
            }
      });
    },
    async openDoor(params) {
      let _reason = "";
      if(!params.reason){
        _reason = this.direction===0 ? this.releaseInReason[this.reasonIndex] : this.releaseOutReason[[this.reasonIndex]];
      }else{
        _reason = params.reason;
      }

      var { message, code } = await oneClickRelease({
        useLogId: this.currentUseLog.id,
        openDoor: 1,
        reason: _reason,
        releaseType: 2,
        direction: this.direction  //0-入场/1-出场
      });
      this.openDoorDialogVisible = false;
      if(code === 10002){
        this.$message({
          message,
          type: "success",
        });
        if(this.direction === 0) {
          this.currentUseLog.inReleaseType = 2;
          var list = cloneDeep(this.inCar);
          list.map((i) => {
            if (i.id === this.currentUseLog.id) {
              i = this.currentUseLog;
            }
          });
          // this.inCar = list;
          store.commit("SETALLIN", list);
          // end

        }else{
          this.currentUseLog.outReleaseType = 2;
          list = cloneDeep(this.outCar);
          list.map((i) => {
            if (i.id === this.currentUseLog.id) {
              i = this.currentUseLog;
            }
          });
          this.outCar = list;
          store.commit("SETALLOUT", this.outCar);
          // end
        }
      }else{
        this.$message({
          message,
          type: "error",
        });
      }
      this.currentUseLog = {};
    },
  },
  watch: {
    provincePickerVisible(val) {
      if (val) {
        this.$nextTick(() => {
          setTimeout(() => {
            document.addEventListener(
              "click",
              this.closeProvincePickerOutside,
              true
            );
          }, 0);
        });
      } else {
        document.removeEventListener(
          "click",
          this.closeProvincePickerOutside,
          true
        );
      }
    },
    editCarDialogVisible(val) {
      if (!val) {
        this.provincePickerVisible = false;
      }
    },
  },
  beforeUnmount() {
    document.removeEventListener(
      "click",
      this.closeProvincePickerOutside,
      true
    );
  },
};
</script>
<style scoped>

.reasonBox {
  width: 90px;
  height: 36px;
  background: #efefef;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #323233;
  line-height: 36px;
  margin-bottom: 16px;
  /* margin-right: 20px; */
  text-align: center;
}

.reasonBox_ac {
  width: 90px;
  height: 36px;
  background: #fc4408;
  border-radius: 3px;
  font-size: 12px;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-weight: 500;
  color: #ffffff;
  line-height: 36px;
  margin-bottom: 16px;
  /* margin-right: 20px; */
  text-align: center;
}

.Box {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}

.release-in-card {
  border: 1px solid #e5e5e5;
  border-radius: 10px;
  background: #f6f6f6;
  padding: 18px 18px 4px;
  overflow: visible;
}

.release-in-form :deep(.el-form-item) {
  margin-bottom: 14px;
}

.release-in-form :deep(.el-form-item__label) {
  color: #999999;
  font-weight: 500;
}

.release-in-value {
  color: #373c40;
  font-size: 14px;
  font-weight: 500;
}

/* 纠错：省份网格 + 车牌输入（参考补录选牌样式） */
.edit-plate-field {
  position: relative;
  width: 100%;
}

.edit-plate-composite {
  display: flex;
  align-items: stretch;
  width: 100%;
  min-height: 36px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  box-sizing: border-box;
}

.edit-plate-composite:focus-within {
  border-color: rgba(8, 123, 252, 0.6);
}

.edit-plate-body-input {
  flex: 1;
  min-width: 0;
}

.edit-plate-body-input :deep(.el-input__wrapper) {
  box-shadow: none !important;
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  padding-left: 10px;
}

.edit-plate-body-input :deep(.el-input__inner) {
  text-align: left;
  border: none !important;
  box-shadow: none !important;
}

.edit-plate-province-badge {
  flex-shrink: 0;
  width: 36px;
  margin: 2px;
  border: none;
  border-radius: 4px;
  background: rgba(8, 123, 252, 1);
  color: #fff;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
}

.edit-plate-province-badge:hover {
  background: rgba(8, 123, 252, 0.85);
}

.edit-plate-keyboard {
  position: absolute;
  left: 0;
  top: calc(100% + 6px);
  z-index: 20;
  padding: 10px;
  background: #f0f2f5;
  border-radius: 8px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
  border: 1px solid #e4e7ed;
  width: 100%;
}

.edit-plate-key-row {
  display: grid;
  grid-template-columns: repeat(10, 1fr);
  gap: 6px;
  margin-bottom: 6px;
}

.edit-plate-key-row:last-child {
  margin-bottom: 0;
}

.edit-plate-key {
  width: 100%;
  aspect-ratio: 1;
  min-width: 0;
  min-height: 32px;
  padding: 0;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  background: #fff;
  font-size: 30px;
  font-weight: 500;
  color: #303133;
  cursor: pointer;
  transition: background 0.15s, color 0.15s, border-color 0.15s;
}

.edit-plate-key:hover {
  border-color: rgba(8, 123, 252, 0.5);
  color: rgba(8, 123, 252, 1);
}

.edit-plate-key.is-active {
  background: #ff9e3c;
  border-color: #ff9e3c;
  color: #fff;
}

.release-in-footer {
  display: flex;
  justify-content: center;
  gap: 12px;
}

.release-in-primary {
  background: rgba(8, 123, 252, 1);
  border-color: rgba(8, 123, 252, 1);
}

.release-in-primary:hover,
.release-in-primary:focus {
  background: rgba(8, 123, 252, 0.9);
  border-color: rgba(8, 123, 252, 0.9);
}

.release-in-dialog :deep(.el-dialog__header) {
  padding-top: 18px;
}

.release-in-dialog :deep(.el-dialog__title) {
  font-size: 20px;
  font-weight: 500;
  color: #373c40;
}

.release-in-dialog :deep(.el-dialog__body) {
  padding-top: 12px;
  padding-bottom: 8px;
  overflow: visible;
}

/* 出场记录：5 列 grid 布局（车牌号、车辆类型、入场时间、出场时间、出场方式） */
.wrap5 :deep(.outer8),
.wrap5 :deep(.main7) {
  display: grid !important;
  grid-template-columns: 68px 73px 100px 74px 110px 1fr;
  align-items: center;
  gap: 4px;
  padding: 0 16px 0 8px;
  width: 100%;
  box-sizing: border-box;
}

/* 消除全局样式中入场/出场时间列自带的 margin-left:10px */
.wrap5 :deep(.word61),
.wrap5 :deep(.word62),
.wrap5 :deep(.info28),
.wrap5 :deep(.info29) {
  margin-left: 0 !important;
}

.wrap5 :deep(.outer8) {
  height: 38px;
}

.wrap5 :deep(.main7) {
  height: 55px;
}

.wrap5 :deep(.word59),
.wrap5 :deep(.word60),
.wrap5 :deep(.word61),
.wrap5 :deep(.word62),
.wrap5 :deep(.txt23),
.wrap5 :deep(.word29),
.wrap5 :deep(.word65),
.wrap5 :deep(.info28),
.wrap5 :deep(.info29),
.wrap5 :deep(.word67) {
  width: auto !important;
  margin-top: 0 !important;
  text-align: center;
}

/* 车辆类型：纯文字，去掉全局 bd14 蓝色底 */
.wrap5 :deep(.bd14) {
  justify-self: center;
  background-color: transparent !important;
  border-radius: 0 !important;
  width: auto !important;
  height: auto !important;
}

.wrap5 :deep(.word66) {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 1) !important;
  width: auto !important;
  height: auto !important;
  text-align: center;
}

/* 入场记录：表头与内容列一一对齐（5 列：车牌号、车辆类型、入场时间、入场方式、操作） */
.section11 :deep(.layer7),
.section11 :deep(.layer9) {
  width: 100%;
}

.section11 :deep(.mod2),
.section11 :deep(.section12) {
  display: grid !important;
  grid-template-columns: 68px 73px 100px 74px 110px 1fr;
  align-items: center;
  gap: 5px;
  /* 右侧多留空，避免操作列按钮贴边 */
  padding: 0 24px 0 12px;
  width: 100%;
  box-sizing: border-box;
}

.section11 :deep(.mod2) {
  height: 38px;
}

.section11 :deep(.section12) {
  height: 55px;
}

.section11 :deep(.word26),
.section11 :deep(.word27),
.section11 :deep(.word28),
.section11 :deep(.txt7),
.section11 :deep(.word29),
.section11 :deep(.word34),
.section11 :deep(.outer5),
.section11 :deep(.info14),
.section11 :deep(.word36) {
  //width: auto !important;
  //margin-top: 0 !important;
}


.section11 :deep(.outer5) {
  justify-self: center;
  background-color: transparent !important;
  border-radius: 0 !important;
  width: auto !important;
  height: auto !important;
}

.section11 :deep(.word35) {
  background-color: transparent !important;
  color: rgba(255, 255, 255, 1) !important;
  width: auto !important;
  height: auto !important;
  text-align: center;
  font-weight: 600;
}

/* 操作列：两个按钮作为一组占一整列，与表头「操作」居中对齐 */
.section11 :deep(.action-group) {
  justify-self: center;
}

/* ── 操作列按钮组 ── */
.action-group {
  display: flex;
  align-items: center;
  gap: 8px;
}

.action-btn {
  height: 34px;
  padding: 0 14px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 34px;
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;
  user-select: none;
}

.action-btn:hover {
  transform: translateY(-1px);
}

.action-btn:active {
  transform: translateY(0);
}

/* 次要操作：纠错 */
.action-btn--warn {
  background: #ffffff;
  color: #ff9e3c;
  border: 1.5px solid #ff9e3c;
}

.action-btn--warn:hover {
  background: rgba(255, 158, 60, 0.08);
}

/* 主要操作：放行 */
.action-btn--primary {
  background: rgba(8, 123, 252, 1);
  color: #ffffff;
  border: 1.5px solid rgba(8, 123, 252, 1);
  min-width: 76px;
  box-sizing: border-box;
}

.action-btn--primary:hover {
  background: rgba(8, 123, 252, 0.9);
  border-color: rgba(8, 123, 252, 0.9);
}

/* 已放行标签 */
.action-tag {
  height: 34px;
  padding: 0 14px;
  border-radius: 4px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-family: PingFangSC-Medium, PingFang SC, serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 34px;
  white-space: nowrap;
  user-select: none;
}

.action-tag--done {
  background: rgba(255, 255, 255, 0.1);
  color: #999999;
  border: 1.5px solid rgba(255, 255, 255, 0.2);
  min-width: 76px;
}

/* 出场操作：取消出场按钮（橙色描边，与纠错一致） */
.action-btn--cancel {
  background: #ffffff;
  color: #ff9e3c;
  border: 1.5px solid #ff9e3c;
  width: 76px;
  box-sizing: border-box;
}

.action-btn--cancel:hover {
  background: rgba(255, 158, 60, 0.08);
}

</style>
